<template>

    <Loader v-if="loader" />

    <div class="card">
        <Toolbar class="p-mb-4">
            <template #start>
                <Button label="Nuovo" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
                <Button label="Cancella" icon="pi pi-trash" class="p-button-danger mr-2" @click="confirmDeleteSelected"
                    :disabled="!selectedRecords || !selectedRecords.length" />
            </template>

            <template #end>
                <Button label="Esporta" icon="pi pi-download" class="p-button-secondary ml-2" @click="exportCSV($event)" />
            </template>
        </Toolbar>

        <div class="p-fluid mb-3 mt-3">
            <div class="grid">
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Data inizio</label>
                    <Calendar v-model="filtroDataInizio" view="month" dateFormat="dd-mm-yy" :showIcon="true"
                        :showButtonBar="true" placeholder="Da" />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Data fine</label>
                    <Calendar v-model="filtroDataFine" view="month" dateFormat="dd-mm-yy" :showIcon="true"
                        :showButtonBar="true" placeholder="A" />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Code</label>
                    <MultiSelect
                        v-model="filterCodes"
                        :options="codeOptions"
                        optionLabel="code"
                        optionValue="code"
                        placeholder="Tutti"
                        display="chip"
                        class="w-full"
                    />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Tipo prezzo</label>
                    <Dropdown v-model="filterTipoPrezzo" :options="prezzi" optionLabel="name" optionValue="code"
                        placeholder="Tutti" showClear class="w-full" />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Voce fattura</label>
                    <Dropdown v-model="filterVoceFattura" :options="voci_fattura" optionLabel="code" optionValue="id"
                        placeholder="Tutte" showClear class="w-full" />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Codice cluster</label>
                    <Dropdown v-model="filterCodCluster" :options="cluster_code" optionLabel="code" optionValue="id"
                        placeholder="Tutti" showClear class="w-full" />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Sezione</label>
                    <Dropdown v-model="filterSezione" :options="sezioniFiltro" optionLabel="sezione" optionValue="sezione"
                        placeholder="Tutte" showClear class="w-full" />
                </div>
                <div class="col-12 md:col-6 lg:col-3 flex align-items-end">
                    <Button type="button" label="Azzera filtri" icon="pi pi-filter-slash" class="p-button-outlined w-full"
                        @click="clearTariffeFilters" />
                </div>
            </div>
        </div>

        <TabView lazy>
            <TabPanel v-for="tab in filteredTabs" :key="tab.title" :header="tab.title">
                <DataTable ref="dt" :value="tab.filteredContent" dataKey="id" responsiveLayout="scroll"
                    v-model:filters="filters" v-model:selection="selectedRecords" :paginator="true" :rows="10"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[10, 20, 50]" :globalFilterFields="globalFilterFields"
                    currentPageReportTemplate="{first} a {last} di {totalRecords}">
                    <template #header>
                        <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                            </span>
                        </div>
                    </template>

                <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
                <Column field="code" header="Code" :sortable="true"></Column>
                <Column field="data_inizio" header="Data inizio" :sortable="true" style="min-width: 130px">
                    <template #body="slotProps">
                        {{ moment(slotProps.data.data_inizio).format('DD-MM-YYYY') }}
                    </template>
                </Column>
                <Column field="data_fine" header="Data fine" :sortable="true" style="min-width: 130px">
                    <template #body="slotProps">
                        {{ moment(slotProps.data.data_fine).format('DD-MM-YYYY') }}
                    </template>
                </Column>
                <Column field="value" header="Valore" :sortable="true"></Column>
                <Column header="Valore utilizzato" :sortable="true">
                    <template #body="slotProps">
                        <span v-if="slotProps.data.cod_type_cluster == 1">
                            {{ ((slotProps.data.value) / 100).toFixed(4) }}
                        </span>
                        <span v-else>
                            {{ ((slotProps.data.value / 12) / 100).toFixed(4) }}
                        </span>
                    </template>
                </Column>
                <Column field="cod_fatt" header="Cod fattura" :sortable="true"></Column>
                <Column field="desc_fatt" header="Desc fattrura" :sortable="true"></Column>
                <Column field="sezione" header="Sezione" :sortable="true"></Column>
                <!-- <Column  field="cod_type_cluster" header="Prezzo" :sortable="true"></Column> -->
                <Column field="cod_type_cluster" header="Prezzo" :sortable="true">
                    <template #body="slotProps">
                        <small class="text-blue-500" v-if="slotProps.data.cod_type_cluster == 1">EURO/KWH</small>
                        <small class="text-green-500" v-if="slotProps.data.cod_type_cluster == 2">EURO/KW</small>
                        <small class="text-orange-500" v-if="slotProps.data.cod_type_cluster == 3">EURO/MESE</small>
                    </template>
                </Column>
                <Column :exportable="false" style="min-width:17rem">
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                            @click="editRecord(slotProps.data)" />
                        <Button icon="pi pi-copy" class="p-button-rounded p-button-help mr-2"
                            @click="openDuplicateRecord(slotProps.data)" />
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-warning"
                            @click="confirmDeleteRecord(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>
        </TabPanel>

        </TabView>
    </div>
    <!-- DIALOG EDIT-->
    <Dialog v-model:visible="recordDialog" :style="{ width: '450px' }" :header="titleDialog" :modal="true"
        class="p-fluid">
        <div class="grid">
            <div class="col-6">
                <div class="p-field">
                    <label for="prezzo">Prezzo </label>
                    <Dropdown id="prezzo" @change="changePrezzo" v-model="selected_prezzo" :options="prezzi"
                        optionLabel="name" optionValue="code" placeholder="Seleziona prezzo" />
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label for="cod_cluster">Codice</label>
                    <Dropdown id="cod_cluster" @change="changeCodeCluster" v-model="selected_cod_cluster"
                        :options="cluster_code" optionLabel="code" optionValue="id" placeholder="Seleziona codice" />
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label for="data_inizio" class="p-mb-3">Data inizio</label>
                    <Calendar id="data_inizio" v-model="record.data_inizio" view="month" dateFormat="dd-mm-yy"
                        :yearNavigator="true" yearRange="2000:2090" />
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label for="data_fine" class="p-mb-3">Data fine</label>
                    <Calendar id="data_fine" v-model="record.data_fine" view="month" dateFormat="dd-mm-yy"
                        :yearNavigator="true" yearRange="2000:2090" />
                </div>
            </div>
            <div class="col-12">
                <div class="p-field">
                    <label for="code">Valore</label>
                    <InputText id="valore" v-model.trim="record.value" required="true" autofocus
                        :value="record.value" />
                </div>
            </div>
            <div class="col-12">
                <div class="p-field">
                    <label for="cod_fattura">Codici Fattura </label>
                    <Dropdown id="cod_fattura" @change="changeCodeFatt" v-model="selected_voce_fatt"
                        :options="voci_fattura" optionLabel="code" optionValue="id" placeholder="Seleziona voce" />
                </div>
            </div>

        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-danger mr-2" @click="hideDialog" />
            <Button :label="record.id ? 'Salva' : 'Crea'" icon="pi pi-check" class="p-button-success mr-2" @click="saveRecord" />
        </template>
    </Dialog>

    <!-- DIALOG DELETE-->
    <Dialog v-model:visible="deleteRecordDialog" :style="{ width: '450px' }" header="Conferma eliminazione"
        :modal="true">
        <div class="confirmation-content flex align-items-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="record">Eliminare questo elemento ?</span>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRecordDialog = false" />
            <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteRecord" />
        </template>
    </Dialog>

    <Dialog v-model:visible="deleteRecordsDialog" :style="{ width: '450px' }" header="Conferma eliminazione"
        :modal="true">
        <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="record">Confermi la cancellazione di {{ selectedRecords.length }} elementi?</span>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRecordsDialog = false" />
            <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteSelectedRecords" />
        </template>
    </Dialog>

</template>

<script>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'

export default {
    components: {
        Loader
    },
    setup() {

        const dt = ref();
        const loader = ref(false)
        const submitted = ref(false);
        const active = ref(0);
        const tabs = ref([]);
        // const pageTitle = ref('');
        const voci_fattura = ref([])
        const selected_voce_fatt = ref(null)
        const selected_prezzo = ref(null)
        const cluster_code = ref([])
        const selected_cod_cluster = ref(null)
        const record = ref({});
        const selectedRecords = ref();
        const recordDialog = ref(false);
        const deleteRecordsDialog = ref(false);
        const titleDialog = ref('');
        const deleteRecordDialog = ref(false);
        const filters = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const globalFilterFields = ['code', 'data_inizio', 'data_fine', 'value', 'cod_fatt', 'desc_fatt', 'sezione', 'cod_type_cluster'];

        const defaultFiltroDateUltimiSeiMesi = () => ({
            inizio: moment().subtract(5, 'months').startOf('month').toDate(),
            fine: moment().endOf('month').toDate(),
        });
        const _defDate = defaultFiltroDateUltimiSeiMesi();
        const filtroDataInizio = ref(_defDate.inizio);
        const filtroDataFine = ref(_defDate.fine);
        const filterCodes = ref([]);
        const filterTipoPrezzo = ref(null);
        const filterVoceFattura = ref(null);
        const filterCodCluster = ref(null);
        const filterSezione = ref(null);

        const asRowArray = (content) => {
            if (!content) {
                return [];
            }
            if (Array.isArray(content)) {
                return content;
            }
            if (typeof content === 'object') {
                return Object.values(content);
            }
            return [];
        };

        const calendarMonthStart = (v) => {
            if (v == null || v === '') {
                return null;
            }
            const m = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)
                ? moment(v.slice(0, 10), 'YYYY-MM-DD', true)
                : moment(v);
            return m.isValid() ? m.clone().startOf('month') : null;
        };
        const calendarMonthEnd = (v) => {
            if (v == null || v === '') {
                return null;
            }
            const m = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)
                ? moment(v.slice(0, 10), 'YYYY-MM-DD', true)
                : moment(v);
            return m.isValid() ? m.clone().endOf('month') : null;
        };

        const parseApiDate = (v) => {
            if (v == null || v === '') {
                return null;
            }
            if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)) {
                return moment(v.slice(0, 10), 'YYYY-MM-DD', true);
            }
            const m = moment(v);
            return m.isValid() ? m : null;
        };

        const openEndDay = moment('2199-12-31').endOf('day');

        const normalizeCode = (value) => String(value ?? '').trim().toUpperCase();

        const applyTariffeEeFilters = (rows, rangeStart, rangeEnd, codes, tipoPrezzo, voceFatt, codCluster, sezione) => {
            const list = asRowArray(rows);
            if (!list.length) {
                return list;
            }
            const selectedCodes = (codes || []).map(normalizeCode).filter(Boolean);
            return list.filter((row) => {
                if (selectedCodes.length && !selectedCodes.includes(normalizeCode(row.code))) {
                    return false;
                }
                if (tipoPrezzo != null && tipoPrezzo !== '' && Number(row.cod_type_cluster) !== Number(tipoPrezzo)) {
                    return false;
                }
                if (voceFatt != null && voceFatt !== ''
                    && Number(row.cod_fattura_voce) !== Number(voceFatt)) {
                    return false;
                }
                if (codCluster != null && codCluster !== ''
                    && Number(row.cod_cluster) !== Number(codCluster)) {
                    return false;
                }
                if (sezione != null && sezione !== '' && row.sezione !== sezione) {
                    return false;
                }
                if (!rangeStart && !rangeEnd) {
                    return true;
                }
                const rs = parseApiDate(row.data_inizio);
                if (!rs || !rs.isValid()) {
                    return false;
                }
                const rowStart = rs.clone().startOf('day');
                const re = parseApiDate(row.data_fine);
                const rowEnd = (re && re.isValid()) ? re.clone().endOf('day') : openEndDay.clone();
                if (rangeStart && rangeEnd) {
                    return rowStart.isSameOrAfter(rangeStart, 'day') && rowEnd.isSameOrBefore(rangeEnd, 'day');
                }
                if (rangeStart) {
                    return rowStart.isSameOrAfter(rangeStart, 'day');
                }
                return rowEnd.isSameOrBefore(rangeEnd, 'day');
            });
        };

        const sezioniFiltro = computed(() => {
            const seen = new Set();
            for (const tab of tabs.value) {
                for (const row of asRowArray(tab.content)) {
                    if (row.sezione != null && String(row.sezione).trim() !== '') {
                        seen.add(String(row.sezione).trim());
                    }
                }
            }
            return [...seen].sort().map((s) => ({ sezione: s }));
        });

        const codeOptions = computed(() => {
            const seen = new Set();
            for (const tab of tabs.value) {
                for (const row of asRowArray(tab.content)) {
                    const code = normalizeCode(row.code);
                    if (code) {
                        seen.add(code);
                    }
                }
            }
            return [...seen].sort().map((code) => ({ code }));
        });

        const filteredTabs = computed(() => {
            const rangeStart = filtroDataInizio.value ? calendarMonthStart(filtroDataInizio.value) : null;
            const rangeEnd = filtroDataFine.value ? calendarMonthEnd(filtroDataFine.value) : null;
            const codes = filterCodes.value;
            const tp = filterTipoPrezzo.value;
            const vf = filterVoceFattura.value;
            const cc = filterCodCluster.value;
            const sz = filterSezione.value;
            if (codes && codes.length) {
                const allRows = tabs.value.flatMap((tab) => asRowArray(tab.content));
                return [{
                    title: 'Risultati filtro code',
                    content: allRows,
                    filteredContent: applyTariffeEeFilters(allRows, rangeStart, rangeEnd, codes, tp, vf, cc, sz),
                }];
            }
            return tabs.value.map((tab) => ({
                title: tab.title,
                content: tab.content,
                filteredContent: applyTariffeEeFilters(tab.content, rangeStart, rangeEnd, codes, tp, vf, cc, sz),
            }));
        });

        const clearTariffeFilters = () => {
            const def = defaultFiltroDateUltimiSeiMesi();
            filtroDataInizio.value = def.inizio;
            filtroDataFine.value = def.fine;
            filterCodes.value = [];
            filterTipoPrezzo.value = null;
            filterVoceFattura.value = null;
            filterCodCluster.value = null;
            filterSezione.value = null;
        };

        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)

        onMounted(() => {
         getData();
       })

        const getData = () => {
            loader.value = true;
            service.getAllTariffe().then((res) => {
                tabs.value = [];
                for (const [key, item] of Object.entries(res.items.tariffe)) {
                    tabs.value.push({ title: key, content: item });
                }
                voci_fattura.value = [];
                cluster_code.value = [];
                for (const item of Object.entries(res.items.cod_fatture)) {
                    voci_fattura.value.push(item[1]);
                }
                for (const item of Object.entries(res.items.cluster_code)) {
                    cluster_code.value.push(item[1]);
                }
            }).finally(() => {
                loader.value = false;
            })
        }

        // const setPageTitle = () => {
        //     pageTitle.value = 'Tariffa Energia Elettrica'; 
        // };
        const exportCSV = () => {
            dt.value.exportCSV()
        };

        const openNew = () => {
            titleDialog.value = 'Nuovo'
            record.value = {};
            selected_prezzo.value = null;
            selected_cod_cluster.value = null;
            selected_voce_fatt.value = null;
            submitted.value = false;
            recordDialog.value = true;
        };

        const editRecord = (prod) => {
            titleDialog.value = 'Modifica';
            const r = { ...prod };
            if (r.data_inizio) {
                r.data_inizio = moment(r.data_inizio).toDate();
            }
            if (r.data_fine) {
                r.data_fine = moment(r.data_fine).toDate();
            }
            record.value = r;
            selected_voce_fatt.value = r.cod_fattura_voce;
            selected_prezzo.value = r.cod_type_cluster;
            selected_cod_cluster.value = r.cod_cluster;
            recordDialog.value = true;
        };

        const cloneRecordForForm = (src) => {
            const copy = { ...src };
            delete copy.id;
            if (copy.data_inizio) {
                copy.data_inizio = moment(copy.data_inizio).toDate();
            }
            if (copy.data_fine) {
                copy.data_fine = moment(copy.data_fine).toDate();
            }
            return copy;
        };

        const syncDropdownsFromRecord = () => {
            const r = record.value;
            selected_voce_fatt.value = r.cod_fattura_voce ?? null;
            selected_prezzo.value = r.cod_type_cluster ?? null;
            selected_cod_cluster.value = r.cod_cluster ?? null;
        };

        const openDuplicateRecord = (prod) => {
            if (!prod) {
                return;
            }
            submitted.value = false;
            titleDialog.value = 'Duplica offerta';
            record.value = cloneRecordForForm(prod);
            syncDropdownsFromRecord();
            recordDialog.value = true;
        };

        const hideDialog = () => {
            submitted.value = false;
            recordDialog.value = false;
        };
        const saveRecord = () => {
            record.value.data_inizio = moment(record.value.data_inizio).format('YYYY-MM-DD')
            record.value.data_fine = moment(record.value.data_fine).format('YYYY-MM-DD')
            if (record.value.id) {
                service.editTariffe(record.value)
                    .then(() => {
                        getData()
                    })
            } else {
                service.createTariffa(record.value)
                    .then(() => {
                        getData()
                    })
            }

            recordDialog.value = false;
            record.value = {};
            selected_prezzo.value = null;
            selected_cod_cluster.value = null;
            selected_voce_fatt.value = null;
        };

        const prezzi = ref([
            { name: 'EURO/KWH', code: 1 },
            { name: 'EURO/KW', code: 2 },
            { name: 'EURO/MESE', code: 3 },
        ]);


        const changeCodeFatt = () => {
            record.value.cod_fattura_voce = selected_voce_fatt.value
        }
        const changePrezzo = () => {
            record.value.cod_type_cluster = selected_prezzo.value
        }
        const changeCodeCluster = () => {
            record.value.cod_cluster = selected_cod_cluster.value
        }

        const confirmDeleteRecord = (prod) => {
            record.value = prod;
            deleteRecordDialog.value = true;
        };
        const deleteRecord = () => {
            service.deleteTariffa(record.value).then(() => {
                getData()
            }).finally(() => {
                deleteRecordDialog.value = false;
                record.value = {};
            })
        };

        const confirmDeleteSelected = () => {
            deleteRecordsDialog.value = true;
        };
        const deleteSelectedRecords = () => {
            service.deleteTariffe(selectedRecords.value).then(() => {
                getData()
            }).finally(() => {
                deleteRecordsDialog.value = false;
                selectedRecords.value = null;
            });
        };

        return {
            moment, dt, active, tabs, filteredTabs, getData, loader, filters, globalFilterFields, selectedRecords, record, exportCSV, editRecord, recordDialog, hideDialog,
            saveRecord, confirmDeleteRecord, deleteRecord, deleteRecordDialog, voci_fattura, selected_voce_fatt,
            changeCodeFatt, prezzi, selected_prezzo, changePrezzo, cluster_code, selected_cod_cluster, changeCodeCluster, openNew,
            titleDialog, confirmDeleteSelected, deleteRecordsDialog, deleteSelectedRecords,
            filtroDataInizio, filtroDataFine, filterCodes, codeOptions, filterTipoPrezzo, filterVoceFattura, filterCodCluster, filterSezione, sezioniFiltro,
            clearTariffeFilters, openDuplicateRecord
        }
    }
}
</script>

<style lang="css">
@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');

.tab-container {
    padding: 20px;
}

.title {
    font-family: "Host Grotesk", serif;
    font-weight: 400;
    font-size: 20px;
    font-style: normal;
    padding: 15px;
}

.card-title {
    background-color: var(--blue-800);
    color: white;
}

.tabview-custom i,
.tabview-custom span {

    vertical-align: middle;
}

.tabview-custom span {
    margin: 0 .5rem;
}


.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.p-tabview .p-tabview-panels {
    padding: 0px !important;
}

.badge-cluster {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 10px;
}

.bg-kwh {
    background-color: rgb(163, 221, 2);
}

.bg-kw {
    background-color: rgb(252, 94, 94);
}

.bg-mese {
    background-color: rgb(152, 230, 240);
}
</style>
